import { berthApiClient } from '../berthApiClient'

import { bookingCallingReceptionEndpoint } from './endpoint'
import type { CallingReceptionCallingResponse, CallingReceptionRequest } from './type'

export const bookingCallingReception = async (
  params: CallingReceptionRequest
): Promise<CallingReceptionCallingResponse> => {
  const res = await berthApiClient.post<CallingReceptionCallingResponse>(
    bookingCallingReceptionEndpoint,
    {
      booking_id: params.bookingId,
      tenant_id: params.tenantId,
      berth_id: params.berthId,
      booking_minute: params.bookingMinute,
      ...(params.shortenTimeFlag != null && { shorten_time_flag: params.shortenTimeFlag }),
      ...(params.prevBookingId && { prev_booking_id: params.prevBookingId }),
    }
  )
  return res.data
}
